import { setInputs } from 'Cloud/Application/Upload.v2';
import React, { createRef, memo, useCallback, useEffect } from 'react';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { TUploadTypeClick } from 'reactApp/modules/upload/upload.model';
import { setButtonTypeClickAction, setUploadFromAction } from 'reactApp/modules/upload/upload.module';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { store } from 'reactApp/store';

import styles from './UploadInput.css';

export const UPLOAD_INPUT_ID = 'UPLOAD_INPUT_ID';

let inputRef;

// Загрузку и выбор файлов для загрузки мы делаем везде через input. Инициируется это кликом по нему.
// Но клик можно делать только в цепочке, в начале которой действие юзера (например, клик по другому элементу),
// иначе браузер пишет ошибку. То есть просто запустить тут асинхронный экшен нельзя.
// Потому тут такой костыль - сохраняем инпут в переменную, и вызываем клик по нему тут.
export function emitUploadStart({ type, from = '' }: { type: TUploadTypeClick; from?: string }) {
    const isOverquotaUser = UserSelectors.isOverQuotaUser(store.getState());

    if (isOverquotaUser) {
        store.dispatch(
            showSnackbarAction({
                id: 'overquota',
                text: 'Превышен объём Облака',
                type: SnackbarTypes.failure,
                closable: true,
            })
        );

        return;
    }

    store.dispatch(setButtonTypeClickAction(type));
    if (from) {
        store.dispatch(setUploadFromAction(from));
    }

    if (type === 'folder') {
        inputRef?.current?.setAttribute('webkitdirectory', true);
    } else {
        inputRef?.current?.removeAttribute('webkitdirectory');
    }
    inputRef?.current?.click();
}

export const UploadInput = memo(() => {
    const ref = createRef<HTMLInputElement>();

    useEffect(() => {
        inputRef = ref;
    }, [ref?.current]);

    useEffect(() => {
        if (ref?.current) {
            setInputs(ref?.current, true);
        }

        return () => {
            inputRef = null;
        };
    }, []);

    const handleClick = useCallback(() => {
        ref?.current?.click();
    }, []);

    return <input id={UPLOAD_INPUT_ID} type="file" multiple className={styles.root} ref={ref} onClick={handleClick} />;
});

UploadInput.displayName = 'UploadInput';
